import axios from "axios";
///import superClassRoom, { doacoes, superStudent } from "@/models/models";
import apiRouter from "./routerNames";
import { doacoes } from "./models";

const router = new apiRouter().doacoes;

export default class DoacoesApi {
  getAll = async () => {
    const resoult = await axios.get(`${router}/all`);
    return resoult.data.data as doacoes[];
  };


  insertItem = async (data: doacoes) => {
    const resolt = await axios.post(`${router}/insert`, data);
    return resolt;
  };
  

}